import axios from 'axios'; 

const instance = axios.create({
	baseURL: 'https://kickoff.metalimits.com/bi',
}); 

export default instance;
